<template>
    <BCard>
       <BRow> 
        <BCol cols="12">
          <h4 class="mb-2">{{$t('Cash configuration')}}</h4> 
        </BCol> 
  
        <!-- Datos de contacto: Left col -->
        <BCol cols="12" xl="6" >
          <table class="mt-2 mt-xl-0 w-100">
            <ViewData vsIcon="HashIcon" vsLabel="Initial balance" :vsValue="group.initial_balance + ' €'" />
          </table>
        </BCol>
  
        <!-- Datos de contacto: Right col -->
        <BCol cols="12" xl="6" >
          <table class="mt-2 mt-xl-0 w-100">
          </table>
        </BCol>
  
      </BRow>
    </BCard>
  </template>
  
  <script>
  import { BCard, BButton, BAvatar, BRow, BCol, BFormCheckbox } from 'bootstrap-vue'
  import { inject } from '@vue/composition-api';
  import ViewData from '@/components/ViewData.vue';
  
  export default {
    components: { BCard, BButton, BRow, BCol, BAvatar, BFormCheckbox, ViewData },
    setup() {
      const group = inject('group')
  
      return {
        group
      }
    },
  }
  </script>
  
  <style lang="scss">
  @import 'src/assets/scss/variables/_variables.scss';
  table tr th {
    color: $primary;
  }
  
  table tr th span {
    text-transform: uppercase;
  }
  </style>
  